import { StockDocument } from "../models"
import { INITIAL_STATE } from "./reducer"

export const stateHandler = (state) => {
    return {
        adjustInventory: () =>{
            return {
                ...state,
                isFetching: true
            }
        },
        
        fetchSuccess: (payload: StockDocument) => {
            return {
                isLoaded: true,
                isFetching: false,
                id: payload.id,
                ...payload.attributes,
            }
        },

        clear: () => {
            return {
                INITIAL_STATE
            }
        },

        markAsDone: () => {
            return {
                ...state,
                isFetching: true
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/stockdocument/reducers/handler.ts